export const DESIGNER_SUMMARY_LABELS = {
    formsOrdered: 'Заказано форм',
    digitalDismountings: 'Цифровых спусков',
    stampsOrdered: 'Заказано штампов',
    formsTotal: ' - Всего',
    overtime: 'Переработка',
    overtimeHours: 'Часы переработки',
    flexo: 'Флекса',
    digital: 'Цифра',
    total: 'Итог',
    flexoCount: 'Формы + штампы',
    ratesHint: 'Ставки премий',
    tasks: 'Задачи',
} as const

/** Ставка премии за 1 час переработки. */
export const OVERTIME_HOUR_RATE = 300

export interface DesignerRateBracket {
    label: string
    rate: number
}

/** Пороги ставки флексы по «Всего». */
export const FLEXO_RATE_BRACKETS: DesignerRateBracket[] = [
    { label: 'Всего ≤ 200', rate: 0 },
    { label: 'Всего > 200', rate: 30 },
    { label: 'Всего > 300', rate: 40 },
    { label: 'Всего > 400', rate: 50 },
    { label: 'Всего > 450', rate: 55 },
]

/** Пороги ставки цифры по числу цифровых спусков. */
export const DIGITAL_RATE_BRACKETS: DesignerRateBracket[] = [
    { label: 'Спусков < 100', rate: 60 },
    { label: 'Спусков ≥ 100', rate: 70 },
    { label: 'Спусков > 200', rate: 80 },
]
